module.exports = __webpack_public_path__ + "img/banner3.62ab1b5b.jpg";